'use strict'; // enforce stricter parsing and error handling

//todo: nested dropdowns don't work 100% perfectly yet (should always close when parent closes) (example: opening, closing and opening a nested dropdown using its control, then closing the parent using esc leads to the nested submenu still being open when re-opening it
//todo: allow for dropdowns to be toggled by hover depending on screen size (not on mobile menus, for example)
//todo: navigation patterns state that dropdowns should close when the focus (tab) leaves an open dropdown
//todo: navigation patterns expect the arrow controls to also move on the top-level dropdowns / links, not just those nested in dropdowns.

/**
 * Dropdown
 * @author Jesse de Vries
 */
function Dropdown(options) {
    this.Init(options);
}

/**
 * Constructor
 * @Param object options
 * @return void
 */

Dropdown.prototype = {
    Init: function (options) { // Initialization

        // Default selectors
        const defaultOptions = {
            dropdowns: '.js-dropdown',
            contents: '.js-dropdown-list', // Toggleable elements
            controls: '.js-dropdown-control', // Controls (buttons) used to toggle elements
            items: '.js-dropdown-item'
        }

        // Merge default options with provided options
        this.options = Object.assign({}, defaultOptions, options);

        // Initialize Prototype variables
        this.dropdowns = document.querySelectorAll(this.options.dropdowns);
        this.items = document.querySelectorAll(this.options.items);
        this.contents = document.querySelectorAll(this.options.contents);
        this.controls = document.querySelectorAll(this.options.controls);

        // Initialize Start function
        this.SetEvents();
    },

    /**
     * SetEvents
     * @return void
     */
    // Event Handling
    SetEvents: function () {
        const _this = this; // Put the current context of 'this' in a variable, so we can always pass it to the next function
        // Create local variables from the Object context
        const dropdowns = this.dropdowns;
        const controls = this.controls;
        const contents = this.contents;
        const items = this.items;

        dropdowns.forEach(function (dropdown) {
            //let control = document.getElementById(dropdown.getAttribute('data-disclosure'));
            let control = dropdown.querySelector('.js-dropdown-control'); //todo: should be a variable declared in init
            let content = document.getElementById(control.getAttribute('aria-controls'));
            control.addEventListener('keydown', function(e) {
                if (e.code === 'ArrowDown') {
                    if (content.getAttribute('data-disclosure-content') === 'open' || control.value !== '') {
                        console.log('test');
                        e.preventDefault();
                        content.querySelector('.js-dropdown-item, .js-dropdown-control').focus(); //todo: should be a variable declared in init
                    } else {
                        // go to next dropdown, if one exists in the group
                    }
                }
            });

            content.addEventListener('keydown', function (e) {
                if (e.code === 'Escape') {
                    control.focus();
                    // close dropdown
                }
            });

        });

        contents.forEach(function(content) {
            content.addEventListener('keydown', function (e) {
                e.stopPropagation();

                let items = Array.from(content.querySelectorAll('.js-dropdown-item, .js-dropdown-control')).filter(item => {
                    return content.contains(item) && item.closest('.js-dropdown-list') === content;
                });

                let active = document.activeElement;
                let index = items.indexOf(active);
                let first = items[0];
                let last = items[items.length - 1];
                let next = items[index + 1];
                let prev = items[index - 1];

                //todo: arrow controls should be adjusted for rtl documents

                switch(e.code) {
                    case 'ArrowDown':
                        e.preventDefault();
                        if (next) {
                            next.focus();
                        } else {
                            first.focus();
                        }
                        break;

                    case 'ArrowUp':
                        e.preventDefault();
                        if (prev) {
                            prev.focus();
                        } else {
                            last.focus();
                        }
                        break;

                    case 'Home':
                        e.preventDefault();
                        first.focus();
                        break;

                    case 'End':
                        e.preventDefault();
                        last.focus();
                        break;
                }
            });
        });

    }

}

export { Dropdown };
